import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCredentials, sendCredentials } from "../../services/services";

// Thunk to fetch credentials
export const fetchCustomerCredentials = createAsyncThunk(
  "credentials/fetchCustomerCredentials",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await fetchCredentials(orderId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Thunk to send credentials
export const sendCustomerCredentials = createAsyncThunk(
  "credentials/sendCustomerCredentials",
  async ({ orderId, credentials }, { rejectWithValue }) => {
    try {
      const response = await sendCredentials(orderId, credentials);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const credentialsSlice = createSlice({
  name: "credentials",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch credentials
      .addCase(fetchCustomerCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerCredentials.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCustomerCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Send credentials
      .addCase(sendCustomerCredentials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendCustomerCredentials.fulfilled, (state, action) => {
        state.loading = false;
        state.sendSuccess = action.payload;
      })
      .addCase(sendCustomerCredentials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default credentialsSlice.reducer;
